import {
  asUtf8ToByteArray29u89fcaeh9ki as asUtf8ToByteArray,
  toUtf8Stringtpd5urkuirog as toUtf8String,
  ArrayIndexOutOfBoundsException3rm3ooo7dx3e8 as ArrayIndexOutOfBoundsException,
} from './NonJvmPlatform.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { charArray2ujmm1qusno00 as charArray } from '../../kotlin-kotlin-stdlib/kotlin/js/arrays.mjs';
import {
  get_HEX_DIGIT_CHARSdv75g3vie5sw as get_HEX_DIGIT_CHARS,
  commonWrite1hq6d430w9jqm as commonWrite,
  access$codePointIndexToCharIndex$tByteStringKt2a2y38zo1jcm as access$codePointIndexToCharIndex$tByteStringKt,
} from './internal/ByteString.mjs';
import {
  concatToString2syawgu50khxi as concatToString,
  substringiqarkczpya5m as substring,
} from '../../kotlin-kotlin-stdlib/kotlin/text/stringJs.mjs';
import {
  arrayRangeEquals1k0armei4gb4e as arrayRangeEquals,
  resolveDefaultParameter3hmb6x0gvzxi7 as resolveDefaultParameter,
} from './Util.mjs';
import {
  contentHashCode25jw6rgkgywwr as contentHashCode,
  copyOfRange3alro60z4hhf8 as copyOfRange,
} from '../../kotlin-kotlin-stdlib/kotlin/collections/_ArraysJs.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { replace3le3ie7l9k8aq as replace } from '../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
import { Comparable198qfk8pnblz0 as Comparable } from '../../kotlin-kotlin-stdlib/kotlin/Comparable.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        var tmp = this;
        // Inline function 'kotlin.byteArrayOf' call
        var tmp$ret$0 = new Int8Array([]);
        tmp.EMPTY_1 = new (ByteString())(tmp$ret$0);
      }
      encodeUtf8_5n709n_k$(_this__u8e3s4) {
        // Inline function 'okio.internal.commonEncodeUtf8' call
        var byteString = new (ByteString())(asUtf8ToByteArray(_this__u8e3s4));
        byteString.set_utf8_1c2rfj_k$(_this__u8e3s4);
        return byteString;
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var ByteStringClass;
function ByteString() {
  if (ByteStringClass === VOID) {
    class $ {
      constructor(data) {
        Companion_getInstance();
        this.data_1 = data;
        this.hashCode_2 = 0;
        this.utf8__1 = null;
      }
      set_hashCode_j8f9eg_k$(value) {
      }
      set_utf8_1c2rfj_k$(value) {
      }
      utf8_255yp_k$() {
        // Inline function 'okio.internal.commonUtf8' call
        var result = this.utf8__1;
        if (result == null) {
          result = toUtf8String(this.internalArray_nlkee4_k$());
          this.set_utf8_1c2rfj_k$(result);
        }
        return result;
      }
      hex_27mj_k$() {
        // Inline function 'okio.internal.commonHex' call
        var result = charArray(imul(this.data_1.length, 2));
        var c = 0;
        var indexedObject = this.data_1;
        var inductionVariable = 0;
        var last = indexedObject.length;
        while (inductionVariable < last) {
          var b = indexedObject[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          var _unary__edvuaz = c;
          c = _unary__edvuaz + 1 | 0;
          var tmp = get_HEX_DIGIT_CHARS();
          // Inline function 'okio.shr' call
          result[_unary__edvuaz] = tmp[b >> 4 & 15];
          var _unary__edvuaz_0 = c;
          c = _unary__edvuaz_0 + 1 | 0;
          var tmp_0 = get_HEX_DIGIT_CHARS();
          // Inline function 'okio.and' call
          result[_unary__edvuaz_0] = tmp_0[b & 15];
        }
        return concatToString(result);
      }
      internalGet_fjh713_k$(pos) {
        if (pos >= this.get_size_woubt6_k$() || pos < 0)
          throw ArrayIndexOutOfBoundsException().new_okio_ArrayIndexOutOfBoundsException_bmu1rv_k$('size=' + this.get_size_woubt6_k$() + ' pos=' + pos);
        // Inline function 'okio.internal.commonGetByte' call
        return this.data_1[pos];
      }
      get_c1px32_k$(index) {
        return this.internalGet_fjh713_k$(index);
      }
      get_size_woubt6_k$() {
        return this.getSize_eczypt_k$();
      }
      getSize_eczypt_k$() {
        // Inline function 'okio.internal.commonGetSize' call
        return this.data_1.length;
      }
      toByteArray_qczt2u_k$() {
        // Inline function 'okio.internal.commonToByteArray' call
        // Inline function 'kotlin.collections.copyOf' call
        // Inline function 'kotlin.js.asDynamic' call
        return this.data_1.slice();
      }
      internalArray_nlkee4_k$() {
        // Inline function 'okio.internal.commonInternalArray' call
        return this.data_1;
      }
      write_ognmlh_k$(buffer, offset, byteCount) {
        return commonWrite(this, buffer, offset, byteCount);
      }
      rangeEquals_tjm4f3_k$(offset, other, otherOffset, byteCount) {
        // Inline function 'okio.internal.commonRangeEquals' call
        return other.rangeEquals_4nzvj0_k$(otherOffset, this.data_1, offset, byteCount);
      }
      rangeEquals_4nzvj0_k$(offset, other, otherOffset, byteCount) {
        // Inline function 'okio.internal.commonRangeEquals' call
        return offset >= 0 && offset <= (this.data_1.length - byteCount | 0) && otherOffset >= 0 && otherOffset <= (other.length - byteCount | 0) && arrayRangeEquals(this.data_1, offset, other, otherOffset, byteCount);
      }
      startsWith_rnhyd8_k$(prefix) {
        // Inline function 'okio.internal.commonStartsWith' call
        return this.rangeEquals_tjm4f3_k$(0, prefix, 0, prefix.get_size_woubt6_k$());
      }
      equals(other) {
        // Inline function 'okio.internal.commonEquals' call
        var tmp;
        if (other === this) {
          tmp = true;
        } else {
          if (other instanceof ByteString()) {
            tmp = (other.get_size_woubt6_k$() === this.data_1.length && other.rangeEquals_4nzvj0_k$(0, this.data_1, 0, this.data_1.length));
          } else {
            tmp = false;
          }
        }
        return tmp;
      }
      hashCode() {
        var tmp$ret$0;
        $l$block: {
          // Inline function 'okio.internal.commonHashCode' call
          var result = this.hashCode_2;
          if (!(result === 0)) {
            tmp$ret$0 = result;
            break $l$block;
          }
          // Inline function 'kotlin.also' call
          var this_0 = contentHashCode(this.data_1);
          this.set_hashCode_j8f9eg_k$(this_0);
          tmp$ret$0 = this_0;
        }
        return tmp$ret$0;
      }
      compareTo_5b1exn_k$(other) {
        var tmp$ret$0;
        $l$block_0: {
          // Inline function 'okio.internal.commonCompareTo' call
          var sizeA = this.get_size_woubt6_k$();
          var sizeB = other.get_size_woubt6_k$();
          var i = 0;
          // Inline function 'kotlin.comparisons.minOf' call
          var size = Math.min(sizeA, sizeB);
          $l$loop: while (i < size) {
            // Inline function 'okio.and' call
            var byteA = this.get_c1px32_k$(i) & 255;
            // Inline function 'okio.and' call
            var byteB = other.get_c1px32_k$(i) & 255;
            if (byteA === byteB) {
              i = i + 1 | 0;
              continue $l$loop;
            }
            tmp$ret$0 = byteA < byteB ? -1 : 1;
            break $l$block_0;
          }
          if (sizeA === sizeB) {
            tmp$ret$0 = 0;
            break $l$block_0;
          }
          tmp$ret$0 = sizeA < sizeB ? -1 : 1;
        }
        return tmp$ret$0;
      }
      compareTo_hpufkf_k$(other) {
        return this.compareTo_5b1exn_k$(other instanceof ByteString() ? other : THROW_CCE());
      }
      toString() {
        var tmp$ret$0;
        $l$block_1: {
          // Inline function 'okio.internal.commonToString' call
          // Inline function 'kotlin.collections.isEmpty' call
          if (this.data_1.length === 0) {
            tmp$ret$0 = '[size=0]';
            break $l$block_1;
          }
          var i = access$codePointIndexToCharIndex$tByteStringKt(this.data_1, 64);
          if (i === -1) {
            var tmp;
            if (this.data_1.length <= 64) {
              tmp = '[hex=' + this.hex_27mj_k$() + ']';
            } else {
              var tmp_0 = this.data_1.length;
              var tmp$ret$2;
              $l$block_0: {
                // Inline function 'okio.internal.commonSubstring' call
                var endIndex = resolveDefaultParameter(this, 64);
                // Inline function 'kotlin.require' call
                if (!(0 >= 0)) {
                  var message = 'beginIndex < 0';
                  throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
                }
                // Inline function 'kotlin.require' call
                if (!(endIndex <= this.data_1.length)) {
                  var message_0 = 'endIndex > length(' + this.data_1.length + ')';
                  throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message_0));
                }
                var subLen = endIndex - 0 | 0;
                // Inline function 'kotlin.require' call
                if (!(subLen >= 0)) {
                  var message_1 = 'endIndex < beginIndex';
                  throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message_1));
                }
                if (0 === 0 && endIndex === this.data_1.length) {
                  tmp$ret$2 = this;
                  break $l$block_0;
                }
                tmp$ret$2 = new (ByteString())(copyOfRange(this.data_1, 0, endIndex));
              }
              tmp = '[size=' + tmp_0 + ' hex=' + tmp$ret$2.hex_27mj_k$() + '\u2026]';
            }
            tmp$ret$0 = tmp;
            break $l$block_1;
          }
          var text = this.utf8_255yp_k$();
          var safeText = replace(replace(replace(substring(text, 0, i), '\\', '\\\\'), '\n', '\\n'), '\r', '\\r');
          var tmp_1;
          if (i < text.length) {
            tmp_1 = '[size=' + this.data_1.length + ' text=' + safeText + '\u2026]';
          } else {
            tmp_1 = '[text=' + safeText + ']';
          }
          tmp$ret$0 = tmp_1;
        }
        return tmp$ret$0;
      }
    }
    initMetadataForClass($, 'ByteString', VOID, VOID, [Comparable()]);
    ByteStringClass = $;
  }
  return ByteStringClass;
}
//region block: exports
export {
  Companion_getInstance as Companion_getInstance1jn7cnltecrtd,
  ByteString as ByteString2qc03wzjsovk,
};
//endregion

//# sourceMappingURL=ByteString.mjs.map
